import {
  GenerateSearchieResponseProto,
  SearchPreviewsResponse,
} from '@fullstory/proto/fs/services/alexa';
import { Duration, duration, int64, Timestamp, timestamp } from '@fullstory/proto/google/protobuf';
import * as segment from '@fullstory/proto/fs/api/segment';
import { GetAllElementPropertyRulesResponse } from '@fullstory/proto/fs/services/search-settings';

export const ELEMENT_PROPERTY_RULES_RESPONSE: GetAllElementPropertyRulesResponse = {
  elementPropertyRules: [],
  activeLimit: 0,
};

export const SEARCH_PREVIEWS_RESPONSE: SearchPreviewsResponse = {
  previews: [],
  computedAt: null,
  backgroundRefId: '',
};

export const GENERATE_SEARCHIE_5_USERS_PAGE_1_RESPONSE: GenerateSearchieResponseProto = {
  generatedSearchie: {
    handle: {
      type: 17,
      matchingUsersSettings: {
        start: 0,
        limit: 5,
        sortOrder: 2,
        additionalSegmentDefinitions: [],
        eventSearch: null,
        earliestInSession: false,
      },
      segmentDefinition: {
        userProperties: [],
        excludeUserProperties: [],
        behaviors: [
          {
            event: {
              primary: {
                click: {
                  any: {},
                },
              },
              deps: [],
            },
          },
        ],
        excludeBehaviors: [],
        constraints: {
          inOrder: false,
          inSameSession: false,
          platform: 0,
          timeRange: {
            startTime: 'NOW/DAY-29DAY',
            endTime: 'NOW/DAY+1DAY',
          },
          completeSessions: false,
          withinTime: Duration.zero,
          eventThresholds: [],
        },
        excludeConstraints: null,
      },
    },
    matchingUsersData: {
      users: [
        {
          indvId: '5671563168841728' as int64,
          createdAt: '2018-10-17T20:09:21.936Z' as timestamp,
          appKey: '',
          displayName: 'User 76',
          email: '',
          lastMatchingPage: 'https://fruitshoppe.firebaseapp.com/#/checkout',
          numSessions: 1,
          fetchClips: false,
          lastMatchingSessionStartAt: '2018-10-17T20:09:21.936Z' as timestamp,
          lastMatchingSessionDuration: '35s' as duration,
          lastMatchingSessionNumPages: 1,
          lastMatchingEventStartAt: '2018-10-17T20:09:21.936Z' as timestamp,
          lastMatchingEventName: '',
          lastMatchingEventVars: [],
          lastMatchingCaptureSourceIntegration: '',
          lastMatchingSessionNumEvents: 31,
          lastMatchingUserSessionId: '5671563168841728!5629499534213120',
          lastMatchingUserSessionPageId: '5671563168841728!5629499534213120',
          lastMatchingEventPageOffset: 0,
          lastMatchingCity: 'Atlanta',
          lastMatchingLatLong: '',
          lastMatchingBrowser: 'Chrome',
          lastMatchingDevice: 'Desktop',
          lastMatchingOperatingSystem: 'OS X',
          totalDuration: '35s' as duration,
          averageSessionDuration: '35s' as duration,
          numEvents: 31,
          vars: [],
          lastPage: 'https://fruitshoppe.firebaseapp.com/#/',
          numMatchingSessions: 1,
          numMatchingOfflineEvents: 0,
          lastMatchingSessionActiveDuration: '24s' as duration,
          lastMatchingIpAddress: '',
          lastMatchingPlatform: segment.Platform.PLATFORM_WEB,
          totalActiveDuration: null,
          averageActiveDuration: null,
          fetchSessionMarkers: false,
        },
        {
          indvId: '5674053578784768' as int64,
          createdAt: '2018-10-17T20:09:21.936Z' as timestamp,
          appKey: '',
          displayName: 'User 75',
          email: '',
          lastMatchingPage: 'https://fruitshoppe.firebaseapp.com/#/checkout',
          numSessions: 1,
          numMatchingSessions: 1,
          numMatchingOfflineEvents: 0,
          fetchClips: false,
          lastMatchingSessionStartAt: '2018-10-17T20:09:21.936Z' as timestamp,
          lastMatchingSessionDuration: '130s' as duration,
          lastMatchingSessionNumPages: 1,
          lastMatchingEventStartAt: '2018-10-17T20:09:21.936Z' as timestamp,
          lastMatchingEventName: '',
          lastMatchingEventVars: [],
          lastMatchingCaptureSourceIntegration: '',
          lastMatchingSessionNumEvents: 42,
          lastMatchingUserSessionId: '5674053578784768!5629499534213120',
          lastMatchingUserSessionPageId: '5671563168841728!5629499534213120',
          lastMatchingEventPageOffset: 0,
          lastMatchingCity: 'Atlanta',
          lastMatchingLatLong: '',
          lastMatchingBrowser: 'Chrome',
          lastMatchingDevice: 'Desktop',
          lastMatchingOperatingSystem: 'OS X',
          totalDuration: '130s' as duration,
          averageSessionDuration: '130s' as duration,
          numEvents: 42,
          vars: [],
          lastPage: 'https://fruitshoppe.firebaseapp.com/#/',
          lastMatchingSessionActiveDuration: '24s' as duration,
          lastMatchingIpAddress: '',
          lastMatchingPlatform: segment.Platform.PLATFORM_WEB,
          totalActiveDuration: null,
          averageActiveDuration: null,
          fetchSessionMarkers: false,
        },
        {
          indvId: '5721589337292800' as int64,
          createdAt: '2018-10-17T20:09:21.936Z' as timestamp,
          appKey: '',
          displayName: 'User 74',
          email: '',
          lastMatchingPage: 'https://fruitshoppe.firebaseapp.com/#/market?staging=true',
          numSessions: 1,
          numMatchingSessions: 1,
          numMatchingOfflineEvents: 0,
          fetchClips: false,
          lastMatchingSessionStartAt: '2018-10-17T20:09:21.936Z' as timestamp,
          lastMatchingSessionDuration: '11s' as duration,
          lastMatchingSessionNumPages: 1,
          lastMatchingEventStartAt: '2018-10-17T20:09:21.936Z' as timestamp,
          lastMatchingEventName: '',
          lastMatchingEventVars: [],
          lastMatchingCaptureSourceIntegration: '',
          lastMatchingSessionNumEvents: 2,
          lastMatchingUserSessionId: '5721589337292800!5629499534213120',
          lastMatchingUserSessionPageId: '5671563168841728!5629499534213120',
          lastMatchingEventPageOffset: 0,
          lastMatchingCity: 'Calgary',
          lastMatchingLatLong: '',
          lastMatchingBrowser: 'Chrome',
          lastMatchingDevice: 'Desktop',
          lastMatchingOperatingSystem: 'OS X',
          totalDuration: '11s' as duration,
          averageSessionDuration: '11s' as duration,
          numEvents: 2,
          vars: [],
          lastPage: 'https://fruitshoppe.firebaseapp.com/#/',
          lastMatchingSessionActiveDuration: '24s' as duration,
          lastMatchingIpAddress: '',
          lastMatchingPlatform: segment.Platform.PLATFORM_WEB,
          totalActiveDuration: null,
          averageActiveDuration: null,
          fetchSessionMarkers: false,
        },
        {
          indvId: '5769048189042688' as int64,
          createdAt: '2018-10-17T20:09:21.936Z' as timestamp,
          appKey: '',
          displayName: 'User 73',
          email: '',
          lastMatchingPage: 'https://fruitshoppe.firebaseapp.com/#/login?staging=true',
          numSessions: 1,
          numMatchingSessions: 1,
          numMatchingOfflineEvents: 0,
          fetchClips: false,
          lastMatchingSessionStartAt: '2018-10-17T20:09:21.936Z' as timestamp,
          lastMatchingSessionDuration: '10s' as duration,
          lastMatchingSessionNumPages: 1,
          lastMatchingEventStartAt: '2018-10-17T20:09:21.936Z' as timestamp,
          lastMatchingEventName: '',
          lastMatchingEventVars: [],
          lastMatchingCaptureSourceIntegration: '',
          lastMatchingSessionNumEvents: 2,
          lastMatchingUserSessionId: '5769048189042688!5629499534213120',
          lastMatchingUserSessionPageId: '5671563168841728!5629499534213120',
          lastMatchingEventPageOffset: 0,
          lastMatchingCity: 'Calgary',
          lastMatchingLatLong: '',
          lastMatchingBrowser: 'Chrome',
          lastMatchingDevice: 'Desktop',
          lastMatchingOperatingSystem: 'OS X',
          totalDuration: '10s' as duration,
          averageSessionDuration: '10s' as duration,
          numEvents: 2,
          vars: [],
          lastPage: 'https://fruitshoppe.firebaseapp.com/#/',
          lastMatchingSessionActiveDuration: '24s' as duration,
          lastMatchingIpAddress: '',
          lastMatchingPlatform: segment.Platform.PLATFORM_WEB,
          totalActiveDuration: null,
          averageActiveDuration: null,
          fetchSessionMarkers: false,
        },
        {
          indvId: '5756836925931520' as int64,
          createdAt: '2018-10-17T20:09:21.936Z' as timestamp,
          appKey: '',
          displayName: 'User 72',
          email: '',
          lastMatchingPage: 'https://fruitshoppe.firebaseapp.com/#/login?staging=true',
          numSessions: 1,
          numMatchingSessions: 1,
          numMatchingOfflineEvents: 0,
          fetchClips: false,
          lastMatchingSessionStartAt: '2018-10-17T20:09:21.936Z' as timestamp,
          lastMatchingSessionDuration: '6s' as duration,
          lastMatchingSessionNumPages: 1,
          lastMatchingEventStartAt: '2018-10-17T20:09:21.936Z' as timestamp,
          lastMatchingEventName: '',
          lastMatchingEventVars: [],
          lastMatchingCaptureSourceIntegration: '',
          lastMatchingSessionNumEvents: 2,
          lastMatchingUserSessionId: '5756836925931520!5629499534213120',
          lastMatchingUserSessionPageId: '5671563168841728!5629499534213120',
          lastMatchingEventPageOffset: 0,
          lastMatchingCity: 'Calgary',
          lastMatchingLatLong: '',
          lastMatchingBrowser: 'Chrome',
          lastMatchingDevice: 'Desktop',
          lastMatchingOperatingSystem: 'OS X',
          totalDuration: '6s' as duration,
          averageSessionDuration: '6s' as duration,
          numEvents: 2,
          vars: [],
          lastPage: 'https://fruitshoppe.firebaseapp.com/#/',
          lastMatchingSessionActiveDuration: '24s' as duration,
          lastMatchingIpAddress: '',
          lastMatchingPlatform: segment.Platform.PLATFORM_WEB,
          totalActiveDuration: null,
          averageActiveDuration: null,
          fetchSessionMarkers: false,
        },
      ],
      matchingCounts: {
        numUsers: '25' as int64,
        numSessions: '50' as int64,
        numEvents: '30' as int64,
      },
    },
  },
  cacheOptions: {
    getIfAgeLessThan: '43200s' as duration,
    computeIfOlderThan: '3600s' as duration,
    skipCache: false,
    queue: 0,
  },
  computedAt: '2021-06-05T15:18:00.515069Z' as timestamp,
  backgroundRefId: '',
  sampleResults: null,
};

export const MATCHING_USERS_RESPONSE: GenerateSearchieResponseProto = {
  generatedSearchie: {
    handle: {
      type: 17,
      matchingUsersSettings: {
        start: 0,
        limit: 5,
        sortOrder: 2,
        additionalSegmentDefinitions: [],
        eventSearch: null,
        earliestInSession: false,
      },
      segmentDefinition: {
        userProperties: [],
        excludeUserProperties: [],
        behaviors: [
          {
            event: {
              primary: {
                click: {
                  any: {},
                },
              },
              deps: [],
            },
          },
        ],
        excludeBehaviors: [],
        constraints: {
          inOrder: false,
          inSameSession: false,
          platform: 0,
          timeRange: {
            startTime: 'NOW/DAY-29DAY',
            endTime: 'NOW/DAY+1DAY',
          },
          completeSessions: false,
          withinTime: Duration.zero,
          eventThresholds: [],
        },
        excludeConstraints: null,
      },
    },
    matchingUsersData: {
      users: [],
      matchingCounts: {
        numUsers: int64.fromNumber(0),
        numSessions: int64.fromNumber(50),
        numEvents: int64.fromNumber(30),
      },
    },
  },
  cacheOptions: {
    getIfAgeLessThan: Duration.fromSeconds(43200),
    computeIfOlderThan: Duration.fromSeconds(3600),
    skipCache: false,
    queue: 0,
  },
  computedAt: Timestamp.now(),
  backgroundRefId: '',
  sampleResults: null,
};
